/* 🤖 this file was generated by svg-to-ts */
export const iccIconNavigateNext: {
  name: 'navigate_next';
  data: string;
} = {
  name: 'navigate_next',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m9.705 6-1.41 1.41 4.58 4.59-4.58 4.59L9.705 18l6-6-6-6Z" fill="currentColor"/></svg>`
};
